import { StyledH2, StyledTextInput } from "@aureskonnect/react-ui";
import classnames from "classnames";
import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import { Button } from "reactstrap";
import { useSnapshot } from "valtio";
import moment from "moment";
import { addMinutes, addHours } from "date-fns";
import { AvGroup, AvForm } from "availity-reactstrap-validation";
import CreatableSelect from "react-select/creatable";

import { store as userStore } from "@components/VerticalLayout/store";
import {
    setDuration,
    setIsModalOpenedOrders,
    setOptionComposite,
    setOrders,
    setPattern,
    setIsValidationNumTheSpot,
    store,
    setIsValidationNumToTake,
    setIsValidationPriceTheSpot,
    setIsValidationPriceToTake,
    setIsValidationPeriodToTake,
    setIsValidationNumDelivrey,
    setFuseauHoraire,
} from "../store";

import { numberMatchWord } from "@constants/index";

import ModalOrders from "./ModalOrders";
import { ConfirmationPauseOrdersMessage } from "./ConfirmationPauseOrdersMessage";
import { store as dataStore } from "./Zone/store";
import { t } from "i18next";
import { ConfirmationTimeZone } from "./ConfirmationTimeZone";
import ErrorToast from "@components/Common/ErrorTost";

const timezone_data = {
    "UTC−12:00": { value: "-1200", countries: ["Baker Island (US)"] },
    "UTC−11:00": {
        value: "-1100",
        countries: [
            "American Samoa",
            "Niue",
            "Samoa",
            "Jarvis Island",
            "Midway Atoll",
            "Palmyra Atoll",
        ],
    },
    "UTC−10:00": {
        value: "-1000",
        countries: [
            "Hawaii (USA)",
            "French Polynesia (Tahiti)",
            "Cook Islands",
            "Johnston Atoll",
        ],
    },
    "UTC−09:30": {
        value: "-0930",
        countries: ["Marquesas Islands (French Polynesia)"],
    },
    "UTC−09:00": {
        value: "-0900",
        countries: ["Alaska (USA)", "Gambier Islands (French Polynesia)"],
    },
    "UTC−08:00": {
        value: "-0800",
        countries: [
            "USA (Pacific Time)",
            "Canada (Pacific Time)",
            "Pitcairn Islands",
        ],
    },
    "UTC−07:00": {
        value: "-0700",
        countries: [
            "USA (Mountain Time)",
            "Canada (Mountain Time)",
            "Mexico (Chihuahua)",
        ],
    },
    "UTC−06:00": {
        value: "-0600",
        countries: [
            "USA (Central Time)",
            "Canada (Central Time)",
            "Mexico (Central Time)",
            "Guatemala",
            "Ecuador (Galápagos)",
        ],
    },
    "UTC−05:00": {
        value: "-0500",
        countries: [
            "USA (Eastern Time)",
            "Canada (Eastern Time)",
            "Colombia",
            "Peru",
            "Ecuador (mainland)",
            "Panama",
            "Jamaica",
        ],
    },
    "UTC−04:00": {
        value: "-0400",
        countries: [
            "Atlantic Time (Canada)",
            "Bolivia",
            "Venezuela",
            "Paraguay",
            "Barbados",
            "Dominican Republic",
        ],
    },
    "UTC−03:30": { value: "-0330", countries: ["Newfoundland (Canada)"] },
    "UTC−03:00": {
        value: "-0300",
        countries: [
            "Argentina",
            "Brazil (eastern regions)",
            "Uruguay",
            "Suriname",
            "French Guiana",
        ],
    },
    "UTC−02:00": {
        value: "-0200",
        countries: ["South Georgia and the South Sandwich Islands"],
    },
    "UTC−01:00": {
        value: "-0100",
        countries: ["Azores (Portugal)", "Cape Verde"],
    },
    "UTC±00:00": {
        value: "0000",
        countries: [
            "UK",
            "Portugal (mainland)",
            "Iceland",
            "Morocco",
            "Gambia",
            "Ghana",
            "Senegal",
        ],
    },
    "UTC+01:00": {
        value: "0100",
        countries: [
            "France",
            "Germany",
            "Spain",
            "Algeria",
            "Nigeria",
            "Tunisia",
            "Italy",
            "Poland",
            "Norway",
            "Sweden",
        ],
    },
    "UTC+02:00": {
        value: "0200",
        countries: [
            "Greece",
            "Egypt",
            "South Africa",
            "Palestine",
            "Finland",
            "Ukraine",
            "Romania",
            "Bulgaria",
            "Turkey",
        ],
    },
    "UTC+03:00": {
        value: "0300",
        countries: [
            "Kenya",
            "Russia (Moscow)",
            "Saudi Arabia",
            "Iraq",
            "Ethiopia",
            "Qatar",
            "Bahrain",
            "Kuwait",
        ],
    },
    "UTC+03:30": { value: "0330", countries: ["Iran"] },
    "UTC+04:00": {
        value: "0400",
        countries: [
            "Azerbaijan",
            "United Arab Emirates",
            "Mauritius",
            "Oman",
            "Georgia",
            "Armenia",
        ],
    },
    "UTC+04:30": { value: "0430", countries: ["Afghanistan"] },
    "UTC+05:00": {
        value: "0500",
        countries: [
            "Pakistan",
            "Uzbekistan",
            "Turkmenistan",
            "Maldives",
            "Tajikistan",
        ],
    },
    "UTC+05:30": { value: "0530", countries: ["India", "Sri Lanka"] },
    "UTC+05:45": { value: "0545", countries: ["Nepal"] },
    "UTC+06:00": {
        value: "0600",
        countries: [
            "Bangladesh",
            "Bhutan",
            "Kazakhstan (eastern regions)",
            "Kyrgyzstan",
        ],
    },
    "UTC+06:30": { value: "0630", countries: ["Myanmar", "Cocos Islands"] },
    "UTC+07:00": {
        value: "0700",
        countries: [
            "Thailand",
            "Vietnam",
            "Cambodia",
            "Indonesia (western regions)",
            "Laos",
        ],
    },
    "UTC+08:00": {
        value: "0800",
        countries: [
            "China",
            "Singapore",
            "Malaysia",
            "Australia (Western)",
            "Philippines",
            "Brunei",
        ],
    },
    "UTC+08:45": { value: "0845", countries: ["Australia (Eucla)"] },
    "UTC+09:00": {
        value: "0900",
        countries: [
            "Japan",
            "South Korea",
            "Indonesia (eastern regions)",
            "Palau",
        ],
    },
    "UTC+09:30": {
        value: "0930",
        countries: ["Australia (Northern Territory, South Australia)"],
    },
    "UTC+10:00": {
        value: "1000",
        countries: [
            "Australia (Queensland, New South Wales, Victoria)",
            "Papua New Guinea",
            "Guam",
            "Russia (Vladivostok)",
        ],
    },
    "UTC+10:30": { value: "1030", countries: ["Lord Howe Island (Australia)"] },
    "UTC+11:00": {
        value: "1100",
        countries: [
            "Solomon Islands",
            "Vanuatu",
            "New Caledonia",
            "Russia (Magadan)",
        ],
    },
    "UTC+12:00": {
        value: "1200",
        countries: [
            "Fiji",
            "New Zealand",
            "Marshall Islands",
            "Tuvalu",
            "Nauru",
        ],
    },
    "UTC+12:45": {
        value: "1245",
        countries: ["Chatham Islands (New Zealand)"],
    },
    "UTC+13:00": { value: "1300", countries: ["Samoa", "Tonga", "Tokelau"] },
    "UTC+14:00": { value: "1400", countries: ["Line Islands (Kiribati)"] },
};

export default function Orders({ selectedRows }: any) {
    const {
        isModalOpenedOrders,
        duration,
        pattern,
        dataSetupApk,
        optionComposite,
        deliveryCity,
        isValidationNumTheSpot,
        isValidationNumToTake,
        isValidationPriceTheSpot,
        isValidationPriceToTake,
        isValidationPeriodToTake,
        isValidationNumDelivrey,
        isDeliveryOpened,
        fuseau_horaire,
    } = useSnapshot(store);
    const { dataZone } = useSnapshot(dataStore);
    const { oneShop } = useSnapshot(userStore);
    const timezoneOptions = Object.entries(timezone_data).map(
        ([label, { value, countries }]) => ({
            value,
            label: `${label} – ${countries.map((c) => t(c)).join(", ")}`,
        })
    );
    const [selectedValue, setSelectedValue] = useState(
        selectedRows[0].fuseau_horraire === ""
            ? "0100"
            : selectedRows[0].fuseau_horraire
    );
    const [value, setValue] = useState("");

    const [isFocused, setIsFocused] = useState(false);
    const [isValidation, setIsValidation] = useState(false);
    const [isMinimumPrice, setIsMinimumPrice] = React.useState<boolean>(
        dataSetupApk[0] !== undefined && dataSetupApk[0].orders.isMinimumPrice
            ? dataSetupApk[0].orders.isMinimumPrice
            : false
    );
    const [isDeferredOrders, setIsDeferredOrders] = React.useState<boolean>(
        Object.values(selectedRows).length > 0
            ? selectedRows[0]["composite Products"].CMD_DIFFERE !== undefined
                ? selectedRows[0]["composite Products"].CMD_DIFFERE.ACITVE
                : false
            : false
    );

    const [isModalConfirmationOpened, setIsModalConfirmationOpened] = useState<
        boolean
    >(false);
    const [message, setMessage] = useState<any>("");

    const [isComingFromModify, setIsComingFromModify] = useState<boolean>(
        false
    );
    const [temps, setTemps] = useState<any>("");

    const [isPauseOrders, setIsPauseOrders] = useState<boolean>(
        selectedRows.length > 0 && selectedRows[0]["Pause orders"]
            ? selectedRows[0]["Pause orders"]
            : false
    );
    useEffect(() => {
        let localTemps: any =
            selectedRows[0] && selectedRows[0]["Temps de préparation"];
        localTemps =
            selectedRows[0] &&
            selectedRows[0]["Temps de préparation"] !== undefined &&
            selectedRows[0]["Temps de préparation"].replaceAll(";", ",");
        localTemps = localTemps && localTemps.split(",");
        setTemps(localTemps);
        if (selectedRows[0] !== undefined) {
            setPattern(
                oneShop
                    ? selectedRows[0].motif_interompre
                    : selectedRows[0].pattern
            );
        }
    }, [selectedRows, oneShop]);

    const [delivery, setDelivery] = React.useState<number>(
        selectedRows.length > 0
            ? selectedRows[0]["Temps de préparation"] !== undefined
                ? Number(temps[2])
                : 30
            : 30
    );

    const [onTheSpot, setOnTheSpot] = React.useState<number>(
        selectedRows.length > 0
            ? selectedRows[0]["Temps de préparation"] !== undefined
                ? Number(temps[0])
                : 15
            : 15
    );

    const [toTake, setToTake] = React.useState<number>(
        selectedRows.length > 0
            ? selectedRows[0]["Temps de préparation"] !== undefined
                ? Number(temps[1])
                : 15
            : 15
    );
    function offsetToHours(offset: string): number {
        const sign = offset.startsWith("-") ? -1 : 1;
        const absOffset = offset.replace("-", "").replace("+", "");

        const hours = parseInt(absOffset.slice(0, 2), 10);
        const minutes = parseInt(absOffset.slice(2), 10);

        return sign * (hours + minutes / 60);
    }
    const [localDuration, setLocalDuration] = React.useState<any>(duration);

    const [localPattern, setLocalPattern] = React.useState<any>(pattern);

    const price =
        selectedRows[0] &&
        selectedRows[0]["minimum price"] !== undefined &&
        JSON.parse(selectedRows[0]["minimum price"]);

    const [numberToTake, setNumberToTake] = useState<number>(
        Object.values(selectedRows).length > 0
            ? price !== null && price.ST_MinCmd.MinEmporter
                ? price.ST_MinCmd.MinEmporter
                : 0
            : 0
    );

    const [numberOnTheSpot, setNumberOnTheSpot] = useState<number>(
        Object.values(selectedRows).length > 0
            ? price !== null && price.ST_MinCmd.MinSurplace
                ? price.ST_MinCmd.MinSurplace
                : 0
            : 0
    );

    const [maximumPeriod, setMaximumPeriod] = useState<number>(
        selectedRows.length > 0
            ? selectedRows[0]["composite Products"].CMD_DIFFERE !== undefined
                ? Number(
                      selectedRows[0]["composite Products"].CMD_DIFFERE.NBR_JOUR
                  )
                : 0
            : 0
    );

    function dateDiff(date1: any, date2: any): any {
        var diff: any = {};
        var tmp = date2 - date1;

        tmp = Math.floor(tmp / 1000);
        diff.sec = tmp % 60;

        tmp = Math.floor((tmp - diff.sec) / 60);
        diff.min = tmp % 60;
        tmp = Math.floor((tmp - diff.min) / 60);
        diff.hour = tmp % 24;

        tmp = Math.floor((tmp - diff.hour) / 24);
        diff.day = tmp;

        return diff;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    let ordersTime: any = new Date(Date.parse(selectedRows[0]?.date));

    const date1 = addHours(new Date(), offsetToHours(fuseau_horaire));

    let timeOrders: any = addMinutes(date1, localDuration.label);

    let date2 = new Date(
        localDuration.label !== undefined ? timeOrders : ordersTime
    );

    let diff = dateDiff(date1, date2);

    useEffect(() => {
        setFuseauHoraire(selectedValue);
        if (
            (duration !== "" &&
                duration.label !== t("Undetermined") &&
                (diff.sec < 0 || diff.min < 0)) ||
            (localDuration.label === undefined &&
                selectedRows[0] !== undefined &&
                selectedRows[0]["Undetermined"] === false &&
                (diff.sec < 0 || diff.min < 0))
        ) {
            setLocalDuration("");
            setDuration("");
            setPattern("");
            setIsMinimumPrice(false);
            setIsPauseOrders(false);
        }
        // eslint-disable-next-line
    }, [duration, t, selectedValue]);

    useEffect(() => {
        setOnTheSpot(
            selectedRows.length > 0
                ? selectedRows[0]["Temps de préparation"] !== undefined
                    ? Number(temps[0])
                    : 15
                : 15
        );
        setDelivery(
            selectedRows.length > 0
                ? selectedRows[0]["Temps de préparation"] !== undefined
                    ? Number(temps[2])
                    : 30
                : 30
        );
        setToTake(
            selectedRows.length > 0
                ? selectedRows[0]["Temps de préparation"] !== undefined
                    ? Number(temps[1])
                    : 15
                : 15
        );
    }, [selectedRows, temps]);

    useEffect(() => {
        let localPattern: any =
            pattern === "PROBLEME TECHNIQUE"
                ? t("Technical problem")
                : pattern === "RUPTURE DE STOCK"
                ? t("Out of stock")
                : pattern === "FERMETURE ANNUELLE"
                ? t("Annual closure")
                : pattern;

        if (pattern.value !== undefined || pattern === "") {
            setLocalPattern(localPattern);
        } else {
            setLocalPattern({ value: localPattern, label: localPattern });
        }

        // Check if the date has passed
        const targetDate = selectedRows[0].date;
        const currentDate = addHours(new Date(), offsetToHours(fuseau_horaire));
        const hasDatePassed = currentDate > targetDate;

        if (
            (selectedRows[0] === undefined ||
                (selectedRows[0] !== undefined &&
                    selectedRows[0]["Undetermined"] === false)) &&
            selectedRows[0]["Pause orders"] === true
        ) {
            setIsPauseOrders(!hasDatePassed);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRows]);

    useEffect(() => {
        if (isDeferredOrders === false) {
            setMaximumPeriod(0);
        }
        // eslint-disable-next-line
    }, [isDeferredOrders]);
    useEffect(() => {
        if (localDuration !== "" && localPattern !== "") {
            setLocalDuration("");
            setLocalPattern("");
            setDuration("");
            setPattern("");
            setIsPauseOrders(false);
        }
        // eslint-disable-next-line
    }, [fuseau_horaire]);

    useEffect(() => {
        let interrompreIndeterliné: boolean =
            localDuration.label === t("Undetermined");
        let interompreJusqua = ` ${moment(timeOrders).format(
            "DD-MM-YYYY"
        )} ${moment(timeOrders).format("HH:mm")}`;

        let timePrepartion = `${onTheSpot};${toTake};${delivery}`;

        let dataPrice: any;
        if (selectedRows[0] && selectedRows[0]["minimum price"] !== null) {
            dataPrice = JSON.parse(selectedRows[0]["minimum price"]);
            dataPrice.ST_MinCmd.MinSurplace = numberOnTheSpot;
            dataPrice.ST_MinCmd.MinEmporter = numberToTake;
            let localCity: any = [];
            deliveryCity !== undefined &&
                deliveryCity.forEach((el: any) => {
                    localCity.push({
                        CodePays: el.CodePays,
                        CodePostale: el[t("Postal code")],
                        FraisGestion: el[t("Management fees")],
                        FraisLivraison: el[t("Shipping costs")],
                        id_apk: el.id_apk,
                        MinCommande: el[t("Minimum amount to place an order")],
                        Pays: el[t("Country")],
                        TauxTva: el.Tva,
                        NomVille: el[t("City")],
                        Department: el.Department,
                        detailsVille: el.detailsVille,
                        InfoVille: el.InfoVille,
                        SousVille: el.SousVille,
                        idTva: el.idTva,
                    });
                });
            dataPrice.STVilleLivraison =
                deliveryCity !== undefined ? localCity : [];
            let localZone: any = [];
            dataZone.data !== undefined &&
                dataZone.data.forEach((el: any) => {
                    localZone.push({
                        DebutDistance: el.DebutDistance,
                        detailsZone: el.detailsZone,
                        FinDistance: el.FinDistance,
                        FraisLivraison: el.FraisLivraison,
                        idTva: el.idTva,
                        infoZone: el.infoZone,
                        MinCommande: el.MinCommande,
                        TauxTva: el.TauxTva,
                    });
                });
            dataPrice.LivraisonVille =
                isDeliveryOpened === "city" ? true : false;
            dataPrice.Livraisonzone =
                isDeliveryOpened === "zone" ? true : false;
            dataPrice.stZoneLivraison =
                localZone.length > 0 ? localZone : dataPrice.stZoneLivraison;
        }

        let composite: any = {
            REGLEGRATUITE: optionComposite.REGLEGRATUITE,
            CMD_DIFFERE: {
                ACITVE: isDeferredOrders,
                NBR_JOUR: maximumPeriod.toString(),
            },
        };
        setOptionComposite(composite);

        setOrders({
            localDuration,
            localPattern,
            isMinimumPrice,
            isDeferredOrders,
            isPauseOrders,
            delivery,
            onTheSpot,
            toTake,
            numberToTake,
            numberOnTheSpot,
            maximumPeriod,
            interrompreIndeterliné,
            interompreJusqua,
            timePrepartion,
            dataPrice,
        });
        // eslint-disable-next-line
    }, [
        deliveryCity,
        onTheSpot,
        duration,
        pattern,
        isMinimumPrice,
        isDeferredOrders,
        isPauseOrders,
        delivery,
        toTake,
        maximumPeriod,
        localDuration,
        selectedRows,
        numberOnTheSpot,
        numberToTake,
        localPattern,
        dataZone,
        t,
    ]);
    useEffect(() => {
        const getPatternText = () => {
            const patternValue = oneShop
                ? selectedRows[0]?.motif_interompre
                : selectedRows[0]?.pattern;

            switch (patternValue) {
                case "PROBLEME TECHNIQUE":
                    return t("Technical problem");
                case "RUPTURE DE STOCK":
                    return t("Out of stock");
                case "FERMETURE ANNUELLE":
                    return t("Annual closure");
                default:
                    return patternValue || "";
            }
        };

        const getSuspensionMessage = () => {
            if (!selectedRows.length || !isPauseOrders) {
                return t("No interrupt commands are enabled");
            }

            const row = selectedRows[0];
            const now = addHours(new Date(), offsetToHours(fuseau_horaire));

            // Case 1: Undetermined suspension
            if (
                row.Undetermined === true ||
                localDuration.label === t("Undetermined")
            ) {
                return `${t(
                    "Orders are suspended for an indefinite period"
                )}, ${t("Pattern")}: ${getPatternText()}`;
            }

            // Case 2: Suspension with specific date from selectedRows

            if (row.date && getPatternText) {
                const suspensionDate = new Date(row.date);

                if (now < suspensionDate && !isModalOpenedOrders) {
                    return `${t("Orders are suspended until")} ${moment(
                        suspensionDate
                    ).format("DD-MM-YYYY HH:mm")}, ${t(
                        "Pattern"
                    )}: ${getPatternText()}`;
                }
            }

            // Case 3: Suspension with duration
            if (
                localDuration.label &&
                localDuration.label !== t("Undetermined") &&
                localDuration !== ""
            ) {
                if (timeOrders.toString() === "Invalid Date") {
                    return `${t("Orders are suspended until")} ${t(
                        "Invalid date"
                    )}, ${t("Pattern")}: ${localPattern.label || ""}`;
                }
                const suspensionDate = new Date(timeOrders);
                if (now < suspensionDate) {
                    return `${t("Orders are suspended until")} ${moment(
                        suspensionDate
                    ).format("DD-MM-YYYY HH:mm")}, ${t("Pattern")}: ${
                        localPattern.label || ""
                    }`;
                }
            }

            // Default case (date passed or no valid suspension)
            return t("No interrupt commands are enabled");
        };

        setMessage(getSuspensionMessage());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pattern,
        selectedRows,
        isPauseOrders,
        localDuration,
        localPattern,
        timeOrders,
        oneShop,
        t,
        fuseau_horaire,
    ]);
    return (
        <div
            style={{
                overflowY: "auto",
                paddingBottom: "200px",
                maxHeight: "90vh",
            }}
        >
            <StyledH2
                style={{
                    font: "normal normal 600 30px/41px Nunito Sans",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-3 mt-2"
            >
                {t("Configuring commands")}
            </StyledH2>
            <StyledH2
                style={{
                    font: "normal normal 600 20px/27px Nunito Sans",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5 px-3 pt-2"
            >
                {t("Preparation time required for an order (in minutes)")}
            </StyledH2>
            <AvForm>
                <AvGroup className="ml-5 d-flex justify-content-align p-2">
                    <span className="mt-2 ml-5" style={{ width: "329px" }}>
                        {t("Delivery")}
                    </span>

                    <StyledTextInput
                        min="0"
                        onKeyPress={(event: any) => {
                            if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                        id="delivery"
                        name="delivery"
                        type="number"
                        onChange={(e: any) => {
                            if (
                                e.target.value.match(numberMatchWord) ||
                                e.target.value === "0"
                            ) {
                                setDelivery(e.target.value);
                                setIsValidationNumDelivrey(false);
                            } else {
                                setIsValidationNumDelivrey(true);
                            }
                        }}
                        value={delivery.toString()}
                        className={classnames(
                            "cac_inp_preparationTimeDelivery",
                            {
                                input__clz:
                                    isValidationNumDelivrey || delivery > 60,
                            }
                        )}
                        style={{
                            width: "110px",

                            marginTop: "5px",
                            height: "40px",
                        }}
                    />

                    {isValidationNumDelivrey && delivery < 60 ? (
                        <div
                            style={{
                                marginTop: "3rem",
                                fontSize: "75%",
                                color: "#f46a6a",

                                marginLeft: "-110px",
                            }}
                        >
                            {t("Please insert a preparation time")}
                        </div>
                    ) : null}
                    {delivery > 60 ||
                    (delivery > 60 && isValidationNumDelivrey) ? (
                        <div
                            style={{
                                marginTop: "3rem",
                                fontSize: "80%",
                                color: "#f46a6a",

                                marginLeft: "-110px",
                            }}
                        >
                            {t("The entered value must be between 0 and 60")}
                        </div>
                    ) : null}
                </AvGroup>

                <AvGroup className="ml-5 d-flex justify-content-align p-2">
                    <span className="mt-2 ml-5" style={{ width: "329px" }}>
                        {t("On the spot")}
                    </span>
                    <StyledTextInput
                        min="0"
                        onKeyPress={(event: any) => {
                            if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                        id="spot"
                        name="spot"
                        type="number"
                        onChange={(e: any) => {
                            if (
                                e.target.value.match(numberMatchWord) ||
                                e.target.value === "0"
                            ) {
                                setOnTheSpot(e.target.value);
                                setIsValidationNumTheSpot(false);
                            } else {
                                setIsValidationNumTheSpot(true);
                            }
                        }}
                        value={onTheSpot.toString()}
                        className={classnames(
                            "mt-2 cac_inp_preparationTimeOnTheSpot",
                            {
                                input__clz:
                                    isValidationNumTheSpot || onTheSpot > 60,
                            }
                        )}
                        style={{
                            width: "110px",
                            height: "40px",
                        }}
                    />

                    {isValidationNumTheSpot ? (
                        <div
                            style={{
                                marginTop: "3rem",
                                fontSize: "75%",
                                color: "#f46a6a",

                                marginLeft: "-110px",
                            }}
                        >
                            {t("Please insert a preparation time")}
                        </div>
                    ) : null}
                    {onTheSpot > 60 ? (
                        <div
                            style={{
                                marginTop: "3rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                                marginLeft: "-110px",
                            }}
                        >
                            {t("The entered value must be between 0 and 60")}
                        </div>
                    ) : null}
                </AvGroup>
                <AvGroup className="ml-5 d-flex justify-content-align p-2">
                    <span className="mt-2 ml-5" style={{ width: "329px" }}>
                        {t("To take")}
                    </span>
                    <StyledTextInput
                        id="take"
                        name="take"
                        type="number"
                        min="0"
                        onKeyPress={(event: any) => {
                            if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                        onChange={(e: any) => {
                            if (
                                e.target.value.match(numberMatchWord) ||
                                e.target.value === "0"
                            ) {
                                setToTake(e.target.value);
                                setIsValidationNumToTake(false);
                            } else {
                                setIsValidationNumToTake(true);
                            }
                        }}
                        value={toTake.toString()}
                        className={classnames(
                            "mt-2 cac_inp_preparationTimeTakeAway",
                            {
                                input__clz:
                                    isValidationNumToTake || toTake > 60,
                            }
                        )}
                        style={{
                            width: "110px",
                            height: "40px",
                        }}
                    />

                    {isValidationNumToTake ? (
                        <div
                            style={{
                                marginTop: "3rem",
                                fontSize: "80%",
                                color: "#f46a6a",

                                marginLeft: "-110px",
                            }}
                        >
                            {t("Please insert a preparation time")}
                        </div>
                    ) : null}
                    {toTake > 60 ? (
                        <div
                            style={{
                                marginTop: "3rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                                marginLeft: "-110px",
                            }}
                        >
                            {t("The entered value must be between 0 and 60")}
                        </div>
                    ) : null}
                </AvGroup>
            </AvForm>
            <div
                className="border-footer__clz"
                style={{ paddingTop: "14px" }}
            />
            <div className="ml-5 d-flex justify-content-between p-2">
                <StyledH2
                    style={{
                        font: "normal normal 600 20px/27px Nunito Sans",
                        color: "#000000",
                        opacity: "1",
                    }}
                    className="ml-1 px-1 pt-2"
                >
                    {t("Minimum price to place an order")}
                </StyledH2>
            </div>
            <AvForm>
                <AvGroup className="ml-5 d-flex justify-content-align p-2">
                    <span className="mt-2 ml-5" style={{ width: "329px" }}>
                        {t("To take")}
                    </span>
                    <StyledTextInput
                        id="priceToTake"
                        name="priceToTake"
                        type="number"
                        className={classnames("cac_inp_minimumPriceTakAway", {
                            input__clz: isValidationPriceToTake,
                        })}
                        min="0"
                        onKeyPress={(event: any) => {
                            const inputValue = event.key;
                            if (!/[0-9]/.test(inputValue)) {
                                event.preventDefault();
                            }
                        }}
                        onChange={(e: any) => {
                            if (
                                e.target.value.match(numberMatchWord) ||
                                e.target.value === "0"
                            ) {
                                setNumberToTake(e.target.value);
                                setIsValidationPriceToTake(false);
                            } else {
                                setIsValidationPriceToTake(true);
                            }
                        }}
                        value={numberToTake.toString()}
                        style={{
                            width: "110px",
                            marginTop: "5px",
                            height: "40px",
                        }}
                    />
                    {isValidationPriceToTake ? (
                        <div
                            style={{
                                marginTop: "3rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                                marginLeft: "-110px",
                            }}
                        >
                            {t("Please insert a price")}
                        </div>
                    ) : null}
                </AvGroup>

                <AvGroup className="ml-5 d-flex justify-content-align p-2">
                    <span className="mt-2 ml-5" style={{ width: "329px" }}>
                        {t("On the spot")}
                    </span>
                    <StyledTextInput
                        id="commandespot"
                        name="spot"
                        type="number"
                        min="0"
                        onKeyPress={(event: any) => {
                            const inputValue = event.key;
                            if (!/[0-9]/.test(inputValue)) {
                                event.preventDefault();
                            }
                        }}
                        onChange={(e: any) => {
                            if (
                                e.target.value.match(numberMatchWord) ||
                                e.target.value === "0"
                            ) {
                                setNumberOnTheSpot(e.target.value);
                                setIsValidationPriceTheSpot(false);
                            } else {
                                setIsValidationPriceTheSpot(true);
                            }
                        }}
                        value={numberOnTheSpot.toString()}
                        className={classnames(
                            "mt-2 cac_inp_minimumPriceOnTheSpot",
                            {
                                input__clz: isValidationPriceTheSpot,
                            }
                        )}
                        style={{
                            width: "110px",
                            height: "40px",
                        }}
                    />
                    {isValidationPriceTheSpot ? (
                        <div
                            style={{
                                marginTop: "3rem",
                                fontSize: "80%",
                                color: "#f46a6a",

                                marginLeft: "-110px",
                            }}
                        >
                            {t("Please insert a price")}
                        </div>
                    ) : null}
                </AvGroup>
            </AvForm>
            <div
                className="border-footer__clz"
                style={{ paddingTop: "14px" }}
            />
            <div className="ml-5 d-flex justify-content-between p-1">
                <StyledH2
                    style={{
                        font: "normal normal 600 20px/27px Nunito Sans",
                        color: "#000000",
                        opacity: "1",
                    }}
                    className="ml-1 px-1 pt-2"
                >
                    {t("Pause orders")}
                </StyledH2>
                <Switch
                    className="cac_icn_interruptCommands"
                    offColor="#faafb4"
                    offHandleColor="#E30613"
                    onColor="#c2eec4"
                    onHandleColor="#34C38F"
                    height={19}
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    checked={isPauseOrders}
                    onChange={(e: any) => {
                        if (fuseau_horaire === "") {
                            ErrorToast(
                                t(
                                    "Attention, to configure command interruption, please choose a time zone."
                                )
                            );
                        } else {
                            setIsComingFromModify(false);
                            if (isPauseOrders === true) {
                                setIsModalConfirmationOpened(true);
                            } else {
                                setIsPauseOrders(!isPauseOrders);
                                setIsModalOpenedOrders(true);
                            }
                        }
                    }}
                />
            </div>

            <div className="d-flex justify-content-between p-1 ml-5">
                <span
                    style={{
                        font: "normal normal normal 16px/21px Segoe UI",
                        marginLeft: "54px",
                    }}
                >
                    {message}
                </span>
                <Button
                    className={classnames("style-button-order__clz", {
                        "not-allowed-icon__clz": !isPauseOrders,
                    })}
                    onClick={() => {
                        setIsModalOpenedOrders(true);
                        setIsComingFromModify(true);
                    }}
                >
                    <span
                        className="cac_btn_editInterruptcommands"
                        style={{
                            font: "normal normal normal 16px/21px Segoe UI",
                            color: "rgb(0, 112, 255)",
                            textDecoration: "underline",
                        }}
                    >
                        {t("Edit")}
                    </span>
                </Button>
            </div>
            <AvForm>
                <AvGroup className="ml-5 d-flex justify-content-align p-2">
                    <span className="mt-2 ml-5" style={{ width: "329px" }}>
                        {t("Shop time zone")}
                    </span>
                    <CreatableSelect
                        isClearable
                        value={
                            timezoneOptions.find(
                                (opt) => opt.value === selectedValue
                            ) || null
                        }
                        className="mb-2 mr-2 "
                        options={timezoneOptions}
                        onChange={(e: any) => {
                            if (
                                message !==
                                t("No interrupt commands are enabled")
                            ) {
                                setIsValidation(true);
                                setValue(e?.value || "");
                            } else {
                                setSelectedValue(e?.value || "");
                            }
                        }}
                        placeholder={t("Select timezone")}
                        styles={{
                            container: (base) => ({ ...base, width: "400px" }),
                            control: (base) => ({
                                ...base,
                                borderRadius: "6px",
                                minHeight: "40px",
                                borderColor: isFocused ? "#83bceb" : "#ccc",
                                boxShadow: isFocused
                                    ? "0 0 4px 4px rgba(131, 192, 243, 0.6)"
                                    : "none",
                            }),
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                            menuList: (base) => ({
                                ...base,
                                maxHeight: "180px",
                                overflowY: "auto",
                            }),
                        }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                    />
                </AvGroup>
            </AvForm>
            <div className="border-footer__clz" />
            <div className="ml-5 d-flex justify-content-between p-2">
                <StyledH2
                    style={{
                        font: "normal normal 600 20px/27px Nunito Sans",
                        color: "#000000",
                        opacity: "1",
                    }}
                    className="ml-1 px-1 pt-2"
                >
                    {t("Deferred orders")}
                </StyledH2>
                <Switch
                    className="cac_icn_deferredOrders"
                    offColor="#faafb4"
                    offHandleColor="#E30613"
                    onColor="#c2eec4"
                    onHandleColor="#34C38F"
                    height={19}
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    checked={isDeferredOrders}
                    onChange={(e: any) => {
                        setIsDeferredOrders(!isDeferredOrders);

                        if (e === false) {
                            setMaximumPeriod(0);
                        }
                    }}
                />
            </div>
            <AvForm>
                <AvGroup
                    className={classnames("ml-5 d-flex justify-content-align", {
                        "not-allowed-icon__clz": !isDeferredOrders,
                    })}
                >
                    <span
                        style={{
                            marginLeft: "54px",
                            width: "330px",
                            paddingBottom: " 17px",
                            paddingTop: "7px",
                        }}
                    >
                        {t("Maximum withdrawal period to respect (in days)")}
                    </span>
                    <StyledTextInput
                        min="0"
                        max="99"
                        onKeyPress={(event: any) => {
                            const inputValue = event.key;
                            if (!/[0-9]/.test(inputValue)) {
                                event.preventDefault();
                            }

                            const combinedValue =
                                event.currentTarget.value + inputValue;

                            const numericValue = parseInt(combinedValue, 10);
                            if (numericValue > 99) {
                                event.preventDefault();
                            }
                        }}
                        id="commande"
                        name="commande"
                        type="number"
                        onChange={(
                            e: any,
                            event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                            if (
                                e.target.value.match(numberMatchWord) ||
                                e.target.value === "0"
                            ) {
                                setMaximumPeriod(e.target.value);
                                setIsValidationPeriodToTake(false);
                            } else {
                                setIsValidationPeriodToTake(true);
                            }
                        }}
                        className={classnames("cac_inp_minimumWithdrawalTime", {
                            input__clz: isValidationPeriodToTake,
                        })}
                        value={maximumPeriod.toString()}
                        style={{
                            width: "110px",
                            marginTop: "-0.25rem",
                            height: "40px",
                        }}
                    />
                    {isValidationPeriodToTake ? (
                        <div
                            style={{
                                marginTop: "36px",
                                fontSize: "80%",
                                color: "#f46a6a",
                                marginLeft: "-110px",
                            }}
                        >
                            {t("Please insert a period")}
                        </div>
                    ) : null}
                </AvGroup>

                <span
                    className="not-allowed-icon__clz  px-4"
                    style={{ marginLeft: "76px" }}
                >
                    {t(
                        "If the value entered is 5 days, then the end customer has the possibility of ordering up to D+5 from the date of order taking."
                    )}
                </span>
            </AvForm>
            {isModalOpenedOrders ? (
                <ModalOrders
                    setLocalDuration={setLocalDuration}
                    localDuration={localDuration}
                    setLocalPattern={setLocalPattern}
                    localPattern={localPattern}
                    isPauseOrders={isPauseOrders}
                    selectedRows={selectedRows}
                    setIsPauseOrders={setIsPauseOrders}
                    isComingFromModify={isComingFromModify}
                    setIsComingFromModify={setIsComingFromModify}
                />
            ) : null}
            {isModalConfirmationOpened ? (
                <ConfirmationPauseOrdersMessage
                    setLocalPattern={setLocalPattern}
                    setLocalDuration={setLocalDuration}
                    setIsModalConfirmationOpened={setIsModalConfirmationOpened}
                    isModalConfirmationOpened={isModalConfirmationOpened}
                    setIsPauseOrders={setIsPauseOrders}
                    isPauseOrders={isPauseOrders}
                />
            ) : null}
            {isValidation ? (
                <ConfirmationTimeZone
                    setSelectedValue={setSelectedValue}
                    isModalOpened={isValidation}
                    setIsModalOpened={setIsValidation}
                    value={value}
                />
            ) : null}
        </div>
    );
}
